import * as _ from "lodash";
import * as React from "react";
import { Brand } from "../model/brand";
import { BrandSelectorItem } from "./brandSelectorItem";

interface BrandSelectorProps {
    selectedBrands: Brand[];
    multipleSelectionEnabled: boolean;
    onSelectedBrandsChanged: (selectedBrands: Brand[]) => void;
}

export class BrandSelector extends React.Component<BrandSelectorProps, {}> {
    constructor(props: BrandSelectorProps) {
        super(props);
        this.onItemSelected = this.onItemSelected.bind(this);
    }

    render(): JSX.Element {
        return <div className="vbox">
            { Brand.AllBrands.map((brand, index) =>
                <BrandSelectorItem key={brand.name}
                                   brand={brand}
                                   index={index}
                                   selected={this.isBrandSelected(brand)}
                                   onSelected={this.onItemSelected}/>) }
        </div>;
    }

    private isBrandSelected(brand: Brand): boolean {
        return _.includes(this.props.selectedBrands, brand);
    }

    private onItemSelected(brand: Brand) {
        let selectedBrands = this.props.selectedBrands;

        if (this.props.multipleSelectionEnabled) {
            let wasSelected = this.isBrandSelected(brand);
            if (wasSelected) {
                if (selectedBrands.length > 1) {
                    selectedBrands = Brand.AllBrands.filter(it => this.isBrandSelected(it) && it != brand);
                }
            } else {
                selectedBrands = Brand.AllBrands.filter(it => this.isBrandSelected(it) || it == brand);
            }
        } else {
            selectedBrands = [brand];
        }

        this.props.onSelectedBrandsChanged(selectedBrands);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/brandSelector.tsx